import React from "react"
import { Trans, useTranslation } from "react-i18next"

import { IconSize } from "shared/types/Icon"
import { ConfirmationOverlay } from "shared/ui/confirmation-overlay/ConfirmationOverlay"
import { Hint } from "shared/ui/hint/Hint"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { Label } from "shared/ui/label/Label"

interface ReplaceAttachmentOverlayConfirmStepProps {
  fileName: string
  disabled: boolean
}

export const ReplaceAttachmentOverlayConfirmStep = React.memo(
  ({ fileName, disabled }: ReplaceAttachmentOverlayConfirmStepProps) => {
    const { t } = useTranslation()

    return (
      <div className="replace-attachment-overlay__step">
        <Label variant="bold">
          <Icon name={IconName.COUNTER_ONE} size={IconSize.SMALL} />
          {t("Attachments.ReplaceOverlay.ConfirmReplacement")}
        </Label>
        <Hint.Root>
          <ConfirmationOverlay.CheckboxConfirmation
            name="isConfirmed"
            disabled={disabled}
            label={
              <Trans
                i18nKey="Attachments.ReplaceOverlay.CheckboxLabel"
                values={{ fileName }}
                components={{ strong: <span className="font-bold" /> }}
              />
            }
          />
        </Hint.Root>
      </div>
    )
  }
)
